import { publicApi } from '@/lib/api/publicClient';
import type { PublicSurveyObject, XySurveyResponseBulk } from '@/lib/api/types';

/**
 * Public survey API — used by /s/:surveyId/:stationId and /public-surveys.
 *
 * Backend routes (PUBLIC, no auth, throttled 10000/min for stadium bursts):
 *   GET  /xy-xurvey/:surveyId/:stationId/object  → survey + steps + components + station + stocks + brandKit
 *   POST /xy-xurvey-response/bulk                → submit responses; decrements stock if `stockId` present
 *
 * Routed through publicAxios so no Authorization header is leaked from a
 * logged-in admin who happens to have a /s/... link open in the same tab.
 */
export const publicSurveyApi = {
  getObject: (surveyId: number, stationId: number) =>
    publicApi.get<PublicSurveyObject>(`/xy-xurvey/${surveyId}/${stationId}/object`),

  /**
   * Bulk-submit a survey response. The backend automatically decrements
   * `xk_event_stock_station.available` when `stockId` is provided and the
   * remaining inventory is > 0.
   *
   * Server returns the persisted XkSurveyResponse rows; each carries the
   * shared `responseId` UUID. The wizard uses this UUID to poll the
   * claim-code endpoint for the §11 Screen 5 countdown UI.
   */
  bulkSubmit: (payload: XySurveyResponseBulk) =>
    publicApi.post<Array<{ id: number; responseId: string }>>(
      '/xy-xurvey-response/bulk',
      payload,
    ),
};
